import { HTTPVerbs as h, ApiConfigService as I, Logger as v, ConfigService as k, request as x } from "@nextgen-web-framework/core";
const f = "comcontentstackas", w = "v2", q = ({ slug: o }) => ({
  url: `/${f}/${w}/pages/${o}`,
  method: h.GET,
  retries: 0,
  timeout: 6e4
}), $ = ({ uId: o }) => ({
  url: `/${f}/${w}/content/${o}`,
  method: h.GET,
  retries: 0,
  timeout: 6e4
}), E = ({ contentType: o, hash: t, entryId: s }) => ({
  url: `/${f}/${w}/live-preview/${o}?entriesUid=${s}&livePreviewHash=${t}`,
  method: h.GET,
  retries: 0,
  timeout: 6e4
}), e = "layout.footer.footer,layout.header,layout.header.notification,layout.header.mega_menu_navigation,layout.header.mobile_bottom_navigation_menu", T = {
  404: {
    uId: "404_page",
    references_groups: e
  },
  master_data_localization: {
    uId: "master_data_localization"
  },
  banner: {
    uId: "hero_banner"
  },
  accordion_component: {
    uId: "accordion_component"
  },
  accordion_component_item: {
    uId: "accordion_component_item"
  },
  image_with_optional_cta: {
    uId: "image_with_optional_cta"
  },
  audio_player: {
    uId: "audio_player"
  },
  about_amway_news: {
    uId: "about_amway_news_page",
    references: "content_section.hero_component.hero_component,navigation",
    references_groups: e
  },
  about_amway_awards: {
    uId: "about_amway_awards_page",
    references: "content_section.hero_component.hero_component,navigation",
    references_groups: e
  },
  about_amway_brands: {
    uId: "about_amway_brands_page",
    references: "navigation",
    references_groups: e
  },
  test_only_about_amway_template: {
    uId: "test_only_about_amway_template",
    references: "content_section.hero_component.hero_component,content_section.amway_promises.amway_promises,content_section.amway_highlights.amway_highlights,content_section.highlights_c.highlights_c,content_section.meet_our_scientists.meet_our_scientists,content_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,content_section.download_links.download_links,content_section.rich_text_component.rich_text_component,content_section.amway_business_links.amway_business_links,content_section.quick_links_design_one.quick_links_design_one,content_section.quick_links_design_two.quick_links_design_two,content_section.steps_to_business_owner.steps_to_business_owner,content_section.resource_carousel.resource_carousel.cards.resource_card,content_section.article_carousel.article_carousel.cards.article_card,content_section.video_section.video_section,content_section.faq_groups.faq_groups,content_section.faqs.faqs,navigations.about_amway_navigation,,content_section.image_with_optional_cta.image_with_optional_cta,content_section.audio_player.audio_player,content_section.text_only.text_only,content_section.image_and_text.image_and_text,content_section.grid_view_image_gallery.grid_view_image_gallery,content_section.accordion_component.accordion_component.items.text_only,content_section.accordion_component.accordion_component.items.text_only,content_section.accordion_component.accordion_component.items.image_and_text",
    references_groups: e
  },
  about_amway_journey: {
    uId: "about_amway_journey_page",
    references: "content_section.hero_component.hero_component,navigation",
    references_groups: e
  },
  shop_by: {
    uId: "shop_by_page",
    references: "shop_by_navigation",
    references_groups: e
  },
  my_shop_onboarding: {
    uId: "my_shop_onboarding_page",
    references: "content_section.hero_banner.hero_banner,content_section.my_shop_features.my_shop_features,content_section.my_shop_article.my_shop_article.text_only,content_section.get_started.get_started"
  },
  payment_methods: {
    uId: "payment_methods"
  },
  news: {
    uId: "about_amway_news_article"
  },
  me_panel: {
    uId: "me_panel"
  },
  header: {
    uId: "header",
    references: "mega_menu_navigation,notification,mobile_bottom_navigation_menu"
  },
  footer: {
    uId: "footer"
  },
  subscription: {
    uId: "subscription_landing_page",
    references: "content_section.hero_banner.hero_banner,content_section.plans_list.plans_list,content_section.faqs.faqs"
  },
  offers: {
    uId: "offers_page",
    references: "content_section.hero_banner.hero_banner,content_section.product_carousal.product_carousal,content_section.featured_display_cards_carousal.featured_display_cards_carousal.items.featured_card",
    references_groups: e
  },
  my_shop_create_edit: {
    uId: "my_shop_create_edit_page",
    references: "text_only"
  },
  my_shop_landing: {
    uId: "my_shop_landing_page",
    references_groups: e
  },
  subscription_plan_details: {
    uId: "subscription_plan_details_page"
  },
  subscription_plan: {
    uId: "subscription_plan",
    references: "plan_tag.subscription_plan_tags"
  },
  profile_images: {
    uId: "profile_images"
  },
  registration_terms_conditions: {
    uId: "registration_terms_conditions"
  },
  account_type_details: {
    uId: "account_type_details"
  },
  registration_page: {
    uId: "registration_page",
    references: "account_type_details,profile_info,terms_and_conditions"
  },
  sign_up_terms_and_condition: {
    uId: "sign_up_terms_and_condition"
  },
  account_type_info: {
    uId: "account_type_info"
  },
  renewal_terms_and_conditions: {
    uId: "renewal_terms_and_conditions"
  },
  find_out_more: {
    uId: "find_out_more"
  },
  sharebar_email: {
    uId: "sharebar_email"
  },
  sitemap: {
    uId: "sitemap_page",
    references: "pages"
  },
  redirections: {
    uId: "redirection_items"
  },
  rewrites: {
    uId: "rewrite_items"
  },
  thank_you: {
    uId: "thank_you_messages"
  },
  progressive_profile_stepper: {
    uId: "progressive_profile_stepper"
  },
  profile_stepper: {
    uId: "profile_stepper"
  },
  shop_finder: {
    uId: "shop_finder",
    references_groups: e
  },
  account: {
    uId: "account_page",
    references_groups: e
  },
  cart: {
    uId: "cart_page",
    references_groups: e
  },
  my_list: {
    uId: "my_list_page",
    references_groups: e
  },
  sub_cart: {
    uId: "sub_cart_page",
    references_groups: e
  },
  category: {
    uId: "category_page",
    references_groups: e
  },
  complete_your_profile: {
    uId: "complete_your_profile_page",
    references_groups: e
  },
  group_order: {
    uId: "group_order_page",
    references_groups: e,
    references: "cancel_codes,order_status,payment_messages"
  },
  my_subscriptions: {
    uId: "my_subscriptions_page",
    references_groups: e
  },
  myshop: {
    uId: "myshop_page",
    references_groups: e
  },
  order_confirmation: {
    uId: "order_confirmation_page",
    references_groups: e,
    references: "order_status,payment_message,fulfillment_types"
  },
  return_create: {
    uId: "return_submit_page",
    references_groups: e,
    references: "return_code"
  },
  return_detail: {
    uId: "return_details_page",
    references_groups: e,
    references: "return_codes"
  },
  delivery_tracking: {
    uId: "delivery_tracking_page",
    references_groups: e,
    references: "delivery_tracking_faq"
  },
  return_submit: {
    uId: "submit_return_page",
    references_groups: e,
    references: "return_terms_and_condition"
  },
  order_details: {
    uId: "order_details_page",
    references_groups: e,
    references: "cancel_codes,order_status,payment_status,payment_message,fulfillment_types"
  },
  order_history: {
    uId: "order_history_page",
    references_groups: e
  },
  product: {
    uId: "product_page",
    references_groups: e
  },
  search: {
    uId: "search_page",
    references_groups: e
  },
  signup_find_out_more: {
    uId: "signup_find_out_more_page",
    references_groups: e
  },
  subscription_checkout: {
    uId: "subscription_checkout_page",
    references_groups: e
  },
  subscription_confirmation: {
    uId: "subscription_confirmation_page",
    references_groups: e
  },
  subscription_plan_page: {
    uId: "subscription_plan_page",
    references_groups: e
  },
  subscription_landing: {
    uId: "subscription_landing_page",
    references: "content_section.hero_banner.hero_banner,content_section.plans_list.plans_list.subscription_plans_list,content_section.faqs.faqs",
    references_groups: e
  },
  subscription_profile: {
    uId: "subscription_profile_page",
    references_groups: e
  },
  login: {
    uId: "login_page"
  },
  global_search: {
    uId: "global_search",
    references: "shop_by_brands.featured_cards,shop_by_category.featured_cards"
  },
  account_dashboard: {
    uId: "account_dashboard"
  },
  mega_menu_navigation: {
    uId: "mega_menu_navigation"
  },
  mobile_bottom_navigation_menu: {
    uId: "mobile_bottom_navigation_menu"
  },
  about_amway_navigation: {
    uId: "about_amway_navigation"
  },
  hero_component: {
    uId: "hero_component"
  },
  rich_text_component: {
    uId: "rich_text_component"
  },
  quick_links_design_one: {
    uId: "quick_links_design_one"
  },
  quick_links_design_two: {
    uId: "quick_links_design_two"
  },
  hero_banner: {
    uId: "hero_banner"
  },
  amway_highlights: {
    uId: "amway_highlights"
  },
  steps_to_business_owner: {
    uId: "steps_to_business_owner"
  },
  download_links: {
    uId: "download_links"
  },
  amway_business_links: {
    uId: "amway_business_links"
  },
  banner_rich_text_component: {
    uId: "banner_rich_text_component"
  },
  amway_promises: {
    uId: "amway_promises"
  },
  meet_our_scientists: {
    uId: "meet_our_scientists"
  },
  featured_cards: {
    uId: "featured_cards"
  },
  notification: {
    uId: "notification"
  },
  product_carousel: {
    uId: "product_carousel"
  },
  video_banner: {
    uId: "video_banner"
  },
  product_carousal_banner: {
    uId: "product_carousal_banner"
  },
  featured_articles_carousal: {
    uId: "featured_articles_carousal"
  },
  fulfillment_types: {
    uId: "fulfillment_types"
  },
  privacy_policy: {
    uId: "privacy_policy",
    references_groups: e
  },
  page_banner: {
    uId: "page_banner",
    references: "image_with_optional_cta.image_with_optional_cta"
  },
  checkout: {
    uId: "checkout_page"
  },
  content_page: {
    uId: "content_page",
    references: "categories",
    references_groups: e
  },
  content_detail: {
    uId: "content_detail",
    references: "content_section.product_carousal.product_carousal,content_section.content_card_carousal.content_card_carousal.items.content_card,content_section.content_detail_gallery.content_detail_gallery,content_section.hero_component.hero_component,content_section.rich_text_component.rich_text_component",
    references_groups: e
  },
  content_card: {
    uId: "content_card"
  },
  main_landing_template: {
    uId: "main_landing_template",
    references: "hero_section.hero_banner,hero_section.video_banner,hero_section.video_banner.video_section,hero_section.standard_banner_no_cta,body_section.amway_promises.amway_promises,body_section.amway_highlights.amway_highlights,body_section.highlights_c.highlights_c,body_section.meet_our_scientists.meet_our_scientists,body_section.featured_cards.featured_cards,body_section.product_carousel.product_carousel,body_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,body_section.product_carousal_banner.product_carousal_banner,body_section.download_links.download_links,body_section.rich_text_component.rich_text_component,body_section.amway_business_links.amway_business_links,body_section.quick_links_design_one.quick_links_design_one,body_section.quick_links_design_two.quick_links_design_two,body_section.video_section.video_section,body_section.faq_groups.faq_groups,body_section.faqs.faqs,layout.footer.footer,layout.header,layout.header.notification,layout.header.mega_menu_navigation,body_section.featured_display_cards_carousal.featured_display_cards_carousal.items.featured_card,body_section.resource_carousel.resource_carousel.cards,body_section.article_carousel.article_carousel.cards,body_section.promotion_carousel.promotion_carousel.cards,body_section.accordion_component.accordion_component.items.text_only,body_section.accordion_component.accordion_component.items.image_and_text,body_section.grid_view_image_gallery.grid_view_image_gallery,body_section.text_only.text_only,body_section.image_and_text.image_and_text,body_section.image_with_optional_cta.image_with_optional_cta,body_section.audio_player.audio_player",
    references_groups: e
  },
  test_only_main_landing_template: {
    uId: "test_only_main_landing_template",
    references: "hero_section.hero_banner,hero_section.video_banner,hero_section.hero_banner,hero_section.video_banner.video_section,hero_section.standard_banner_no_cta,body_section.amway_promises.amway_promises,body_section.amway_highlights.amway_highlights,body_section.highlights_c.highlights_c,body_section.meet_our_scientists.meet_our_scientists,body_section.featured_cards.featured_cards,body_section.product_carousel.product_carousel,body_section.featured_display_cards_carousal.featured_display_cards_carousal.items.featured_card.featured_display_card,body_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,body_section.product_carousal_banner.product_carousal_banner,body_section.download_links.download_links,body_section.rich_text_component.rich_text_component,body_section.amway_business_links.amway_business_links,body_section.quick_links_design_one.quick_links_design_one,body_section.quick_links_design_two.quick_links_design_two,body_section.video_section.video_section,body_section.resource_carousel.resource_carousel.cards.resource_card,body_section.article_carousel.article_carousel.cards.article_card,body_section.promotion_carousel.promotion_carousel.cards.promotion_card,body_section.faq_groups.faq_groups,body_section.faqs.faqs,body_section.image_with_optional_cta.image_with_optional_cta,body_section.audio_player.audio_player,body_section.text_only.text_only,body_section.image_and_text.image_and_text,body_section.grid_view_image_gallery.grid_view_image_gallery,body_section.accordion_component.accordion_component.items.text_only,body_section.accordion_component.accordion_component.items.text_only,body_section.accordion_component.accordion_component.items.image_and_text",
    references_groups: e
  },
  flex_template: {
    uId: "flex_template",
    references: "content_section.hero_component.hero_component,content_section.amway_promises.amway_promises,content_section.amway_highlights.amway_highlights,content_section.highlights_c.highlights_c,content_section.meet_our_scientists.meet_our_scientists,content_section.featured_cards.featured_cards,content_section.product_carousel.product_carousel,content_section.featured_display_cards_carousal.featured_display_cards_carousal.items.featured_card.featured_display_card,content_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,content_section.product_carousal_banner.product_carousal_banner,content_section.download_links.download_links,content_section.rich_text_component.rich_text_component,content_section.amway_business_links.amway_business_links,content_section.quick_links_design_one.quick_links_design_one,content_section.quick_links_design_two.quick_links_design_two,content_section.steps_to_business_owner.steps_to_business_owner,content_section.resource_carousel.resource_carousel.cards.resource_card,content_section.article_carousel.article_carousel.cards.article_card,content_section.promotion_carousel.promotion_carousel.cards.promotion_card,content_section.video_section.video_section,content_section.faq_groups.faq_groups,content_section.faqs.faqs,content_section.image_with_optional_cta.image_with_optional_cta,content_section.audio_player.audio_player,content_section.text_only.text_only,content_section.image_and_text.image_and_text,content_section.grid_view_image_gallery.grid_view_image_gallery,content_section.accordion_component.accordion_component.items.text_only,content_section.accordion_component.accordion_component.items.image_and_text,content_section.video_section.video_section",
    references_groups: e
  },
  order_status: {
    uId: "order_status"
  },
  package_status: {
    uId: "package_status"
  },
  resource_and_download_page: {
    uId: "resource_and_download_page",
    references: "navigations.navigations,categories.parent_category,parent_category",
    references_groups: e
  },
  resource_card: {
    uId: "resource_card",
    references: "parent_category.content_category,content_category.content_sub_category"
  },
  promotion_listing_page: {
    uId: "promotion_listing_page",
    references: "categories.parent_category,parent_category",
    references_groups: e
  },
  promotion_card: {
    uId: "promotion_card",
    references: "parent_category.content_category,content_category.content_sub_category"
  },
  resource_detail_template: {
    uId: "resource_detail_template",
    references: "hero_section.resource_overview.resource_overview,body_section.amway_promises.amway_promises,body_section.amway_highlights.amway_highlights,body_section.highlights_c.highlights_c,body_section.meet_our_scientists.meet_our_scientists,body_section.featured_cards.featured_cards,body_section.product_carousel.product_carousel,body_section.featured_display_cards_carousal.featured_display_cards_carousal.items.featured_card.featured_display_card,body_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,body_section.product_carousal_banner.product_carousal_banner,body_section.rich_text_component.rich_text_component,body_section.amway_business_links.amway_business_links,body_section.quick_links_design_one.quick_links_design_one,body_section.quick_links_design_two.quick_links_design_two,body_section.video_section.video_section,body_section.steps_to_business_owner.steps_to_business_owner,body_section.faq_groups.faq_groups,body_section.faqs.faqs,body_section.image_with_optional_cta.image_with_optional_cta,body_section.audio_player.audio_player,body_section.text_only.text_only,body_section.image_and_text.image_and_text,body_section.grid_view_image_gallery.grid_view_image_gallery,body_section.accordion_component.accordion_component.items.text_only,body_section.accordion_component.accordion_component.items.image_and_text,body_section.promotion_carousel.promotion_carousel.cards,body_section.article_carousel.article_carousel.cards,body_section.resource_carousel.resource_carousel.cards",
    references_groups: e
  },
  article_detail_template: {
    uId: "article_detail_template",
    references: "hero_section.article_overview.article_overview,hero_section.article_overview.audio_player,body_section.amway_promises.amway_promises,body_section.amway_highlights.amway_highlights,body_section.highlights_c.highlights_c,body_section.meet_our_scientists.meet_our_scientists,body_section.featured_cards.featured_cards,body_section.product_carousel.product_carousel,body_section.featured_display_cards_carousal.featured_display_cards_carousal.items.featured_card.featured_display_card,body_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,body_section.product_carousal_banner.product_carousal_banner,body_section.rich_text_component.rich_text_component,body_section.amway_business_links.amway_business_links,body_section.quick_links_design_one.quick_links_design_one,body_section.quick_links_design_two.quick_links_design_two,body_section.video_section.video_section,body_section.steps_to_business_owner.steps_to_business_owner,body_section.faq_groups.faq_groups,body_section.faqs.faqs,body_section.image_with_optional_cta.image_with_optional_cta,body_section.text_only.text_only,body_section.image_and_text.image_and_text,body_section.grid_view_image_gallery.grid_view_image_gallery,body_section.accordion_component.accordion_component.items.text_only,body_section.accordion_component.accordion_component.items.image_and_text,body_section.promotion_carousel.promotion_carousel.cards,body_section.article_carousel.article_carousel.cards,body_section.resource_carousel.resource_carousel.cards",
    references_groups: e
  },
  promotion_detail_template: {
    uId: "promotion_detail_template",
    references: "hero_section.promotion_overview.promotion_overview,body_section.amway_promises.amway_promises,body_section.amway_highlights.amway_highlights,body_section.highlights_c.highlights_c,body_section.meet_our_scientists.meet_our_scientists,body_section.featured_cards.featured_cards,body_section.product_carousel.product_carousel,body_section.featured_display_cards_carousal.featured_display_cards_carousal.items.featured_card.featured_display_card,body_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,body_section.product_carousal_banner.product_carousal_banner,body_section.rich_text_component.rich_text_component,body_section.amway_business_links.amway_business_links,body_section.quick_links_design_one.quick_links_design_one,body_section.quick_links_design_two.quick_links_design_two,body_section.video_section.video_section,body_section.steps_to_business_owner.steps_to_business_owner,body_section.faq_groups.faq_groups,body_section.faqs.faqs,body_section.image_with_optional_cta.image_with_optional_cta,body_section.audio_player.audio_player,body_section.text_only.text_only,body_section.image_and_text.image_and_text,body_section.grid_view_image_gallery.grid_view_image_gallery,body_section.accordion_component.accordion_component.items.text_only,body_section.accordion_component.accordion_component.items.image_and_text,body_section.promotion_carousel.promotion_carousel.cards,body_section.article_carousel.article_carousel.cards,body_section.resource_carousel.resource_carousel.cards",
    references_groups: e
  },
  about_amway_template: {
    uId: "about_amway_template",
    references: "content_section.hero_component.hero_component,content_section.amway_promises.amway_promises,content_section.amway_highlights.amway_highlights,content_section.highlights_c.highlights_c,content_section.meet_our_scientists.meet_our_scientists,content_section.featured_articles_carousal.featured_articles_carousal.items.featured_article,content_section.download_links.download_links,content_section.rich_text_component.rich_text_component,content_section.amway_business_links.amway_business_links,content_section.quick_links_design_one.quick_links_design_one,content_section.quick_links_design_two.quick_links_design_two,content_section.steps_to_business_owner.steps_to_business_owner,content_section.resource_carousel.resource_carousel.cards.resource_card,content_section.article_carousel.article_carousel.cards.article_card,content_section.video_section.video_section,content_section.faq_groups.faq_groups,content_section.faqs.faqs,navigations.about_amway_navigation,content_section.image_with_optional_cta.image_with_optional_cta,content_section.audio_player.audio_player,content_section.text_only.text_only,content_section.image_and_text.image_and_text,content_section.grid_view_image_gallery.grid_view_image_gallery,content_section.accordion_component.accordion_component.items.text_only,content_section.accordion_component.accordion_component.items.image_and_text",
    references_groups: e
  },
  a_point_catalog_template: {
    uId: "a_point_catalog_template",
    references: "hero_section.standard_banner_no_cta,body_section.a_point_product_carousel.a_point_product_carousel",
    references_groups: e
  },
  instalment_payment_plan: {
    uId: "instalment_payment_plan"
  },
  coupon: {
    uId: "coupon",
    references_groups: e
  },
  bank_account_terms_conditions: {
    uId: "bank_account_terms_conditions"
  },
  text_only: {
    uId: "text_only"
  },
  grid_view_image_gallery: {
    uId: "grid_view_image_gallery"
  },
  payment_method_terms_and_conditions: {
    uId: "payment_method_terms_and_conditions"
  },
  bank_detail: {
    uId: "bank_detail"
  }
}, g = T, A = async (o) => {
  const t = I.getBaseUrl(), s = o.url.startsWith("http") ? o.url : `${t}${o.url}`, _ = {
    "Content-Type": "application/json",
    ...I.getTuples() || {},
    ...o.headers
  }, a = {
    method: o.method ?? "GET",
    headers: _,
    body: o.body ? JSON.stringify(o.body) : void 0
  }, n = await fetch(s, a);
  if (!n.ok)
    throw new Error(`Fetch Request failed with status ${n.status}`);
  return n.json();
}, u = v.getInstance(), p = (o, t, s, _) => {
  let a = "";
  if (o || t) {
    let n = `${_ ? "&" : "?"}references=`;
    o && (n += o), t && (n += `,${t}`), a += n;
  }
  if (s != null && s.length) {
    let n = "";
    n = s.map(
      (c, r) => `${r === 0 && !(o || t) ? "?" : "&"}${c.key}=${c.value}`
    ).join(""), a += n;
  }
  return a;
}, y = async (o, t) => {
  const s = k.getConfigs();
  t != null && t.headers && (o.headers = t == null ? void 0 : t.headers), t != null && t.baseURL && (o.url = `${t.baseURL}${o.url}`);
  const _ = s.NEXT_REQUEST_VERSION_V2 ? await x(o) : await A(o);
  return Promise.resolve(_);
}, b = (o, t) => {
  const s = k.getConfigs(), _ = `${t ? "&" : "?"}stack=dev`;
  return s.NEXT_STACK_DEV_ENABLE ? `${o}${t}${_}` : `${o}${t}`;
}, L = {
  async fetchContent({ uId: o, params: t, includeCount: s }, _) {
    const a = await this.fetchAllContent({ uId: o, params: t, includeCount: s }, _);
    return Array.isArray(a) ? (a == null ? void 0 : a.length) > 0 ? a[0] : {} : a;
  },
  async fetchAllContent({ uId: o, params: t, includeCount: s }, _, a = !0) {
    try {
      const n = g[o], { uId: c, references: r = "", references_groups: l = "" } = n, i = $({
        uId: c
      }), m = a ? p(r, l, t) : p("", "", t);
      i.url = b(i.url, m), u.info("cms CONTENT SDK URL - ", i.url);
      const d = await y(i, _);
      return s ? { data: d == null ? void 0 : d.data, count: d == null ? void 0 : d.count } : d == null ? void 0 : d.data;
    } catch (n) {
      throw u.error("cms CONTENT SDK FAILURE - ", n), n;
    }
  },
  async fetchLivePreview({ contentType: o, hash: t, entryId: s, params: _ }, a) {
    try {
      const n = g[o], { uId: c, references: r = "", references_groups: l = "" } = n, i = E({
        contentType: c,
        hash: t,
        entryId: s
      }), m = p(r, l, _, !0);
      return i.url = b(i.url, m), u.info("cms LIVE PREVIEW SDK URL - ", i.url), await y(i, a);
    } catch (n) {
      throw u.error("cms LIVE PREVIEW SDK FAILURE - ", n), n;
    }
  },
  async fetchPage({ slug: o, template: t }, s) {
    const _ = await this.fetchAllPages({ slug: o, template: t }, s);
    return Array.isArray(_) ? _.length > 0 ? _[0] : {} : _;
  },
  async fetchAllPages({ slug: o, template: t }, s) {
    try {
      const _ = q({
        slug: o
      });
      if (t) {
        const n = g[t], { uId: c, references: r = "", references_groups: l = "" } = n;
        _.url = `${_.url}?template=${c}`;
        const i = p(r, l, void 0, !0);
        _.url = b(_.url, i);
      }
      const a = await y(_, s);
      return u.info("cms PAGE SDK URL - ", _.url), a == null ? void 0 : a.data;
    } catch (_) {
      throw u.error("cms PAGE SDK FAILURE - ", _), _;
    }
  }
};
export {
  L as U
};
//# sourceMappingURL=cmsApi-530d7204.mjs.map
